import { Button, Checkbox, FormControlLabel, Grid, MenuItem, TextField } from "@mui/material";
import { useContext } from "react";
import { toolsContext } from '../ToolsContext';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { FilterContainer } from "components";
import { applicationContext } from "helpers/services";

let Filter = () => {

    let { toolTypologies } = useContext(applicationContext);
    let service = useContext(toolsContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch(service.search)}>
            <Grid item>
                <TextField
                    select
                    variant="standard"
                    label="Tipologia"
                    value={service.search.typologyId}
                    onChange={(e: any) => service.handleChange({ ...service.search, typologyId: e.target.value })}
                >
                    <MenuItem value=''>Qualsiasi</MenuItem>
                    {toolTypologies.map(u =>
                        <MenuItem key={u.toolTypologyId} value={u.toolTypologyId}>{u.name}</MenuItem>
                    )}
                </TextField>
            </Grid>
            <Grid item>
                <TextField
                    label="Cerca strumenti"
                    variant="standard"
                    id="search text"
                    value={service.search.searchText}
                    onChange={(e: any) => service.handleChange({ ...service.search, searchText: e.target.value })}
                />
            </Grid>

            <Grid item>
                <FormControlLabel
                    label={"Necessita di Manutenzione"}
                    name="needMaintenance"
                    control={<Checkbox
                        checked={service.search.needMaintenance}
                        onChange={(e, value) => service.handleChange({ ...service.search, needMaintenance: value === true ? true : false })}
                        name="needMaintenance"
                        color="secondary"
                    />}
                />
            </Grid>
            <Grid item>
                <FormControlLabel
                    label={"Disponibile"}
                    name="isAvailable"
                    control={
                        <Checkbox
                            checked={service.search.isAvailable}
                            onChange={(e, value) => service.handleChange({ ...service.search, isAvailable: value === true ? true : false })}
                            name="isAvailable"
                            color="secondary"
                        />
                    }
                />
            </Grid>
            <Grid item>
                <Button
                    type="submit"
                    color="secondary"
                    variant="outlined"
                    aria-label="cerca"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filter;